import React from 'react';
import cx from 'classnames';
import { TestimonialCard } from '@zola/zola-ui';

import SectionContainer from '../SectionContainer/SectionContainer';

import styles from './RegistryTestimonialsSection.module.less';

const testimonials = [
  {
    personName: 'Christiana & Bradley',
    header: 'Super easy',
    description:
      '"Target was complicated. Amazon was also complicated. Bad completions discounts. Zola can\'t be beat!"',
  },
  {
    personName: 'Janey & Mel',
    header: 'So easy and best discount',
    description: '"Go with Zola. We tried The Knot first and it crashed all the time."',
  },
  {
    personName: 'Indya & Kordell',
    header: 'We love you, Zola!!',
    description:
      '"Despite their popularity, Target and Bed Bath & Beyond were far more limiting in the items to select from."',
  },
];

const RegistryTestimonialsSection = () => {
  return (
    <SectionContainer className={styles.sectionColor}>
      <div className={styles.container}>
        <h1>
          Hear From Real
          <br />
          Zola Couples
        </h1>
        <div className={styles.cardContainer}>
          {testimonials.map((t, i) => (
            <TestimonialCard
              key={i}
              personName={t.personName}
              header={t.header}
              description={t.description}
              rating={5}
              className={cx([
                styles.card,
                {
                  [styles.cardSpacing]: i !== 0,
                },
              ])}
            />
          ))}
        </div>
      </div>
    </SectionContainer>
  );
};

export default RegistryTestimonialsSection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/RegistryTestimonialsSection/RegistryTestimonialsSection.jsx